import axiosInstance from "../../config/axios-config";
import i18n from "i18next";

export const getTenant = async ({order, config = {}}) => {
    try {
        const responsePharmacy = await axiosInstance.get(`/api/v1/tenants/${order.pharmacyId}`, {
            ...config,
            headers: {
                "Language-Context": i18n.language.toUpperCase() || "EN",
            },
        })
        return responsePharmacy.data
    } catch (error) {
        console.error("Error fetching orders:", error)
    }
}

export const getOrderProducts = async ({order, config = {}}) => {
    const responseOrderProducts = await axiosInstance.get(`/api/v1/orders/importer/product-orders`, {
        ...config,
        params: {
            orderDate: order.orderDate,
            pharmacyId: order.pharmacyId
        },
        headers: {
            "Language-Context": i18n.language.toUpperCase() || "EN",
        },
    })
    return responseOrderProducts.data
}

export const buildShippingAddress = ({pharmacy}) => {
    if (!pharmacy || !pharmacy.address) {
        return '';  // or return null, or 'N/A'
    }
    const { country, city, street } = pharmacy.address;

    // filter out undefined / null / empty and join with comma
    return [street, city, country].filter(Boolean).join(', ');
};
